import { render, staticRenderFns } from "./AboutChinaPostalAirlines.vue?vue&type=template&id=00ed2832&scoped=true&"
import script from "./AboutChinaPostalAirlines.vue?vue&type=script&lang=js&"
export * from "./AboutChinaPostalAirlines.vue?vue&type=script&lang=js&"
import style0 from "./AboutChinaPostalAirlines.vue?vue&type=style&index=0&id=00ed2832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ed2832",
  null
  
)

export default component.exports